var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAramInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#565691",
    d: "M16.714 0L0 16.714V20h3.286L20 3.286V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.965 1.25L1.25 12.965v-2.5l9.214-9.215h2.501zM18.75 7.036v2.5L9.536 18.75h-2.5L18.75 7.035z",
    fill: "#383864"
  }))));
}
export default __webpack_public_path__ + "static/_/shared/assets/svg/roles/aram-inactive.svg";
export { SvgAramInactive as ReactComponent };